export default __webpack_public_path__ + "static/media/usp.28b975de.svg";